export class QualityControlDirt {
    id!: string
    job!: string
    descriptionOfWork!: string
    materialType!: string
    vendor!: number | undefined
    product!: string
    minimumLift!: string
    requiredDepth!: string
    minimumTest!: string
    requiredCompaction!: string
    optimumMoisture!: string
    pitLocation!: string
    proctorDate!: string
    dispatchContact!: string
    testingCompanyVendorId!: number | undefined
    createdOn!: Date
    modifiedOn!: Date
}
